export default __webpack_public_path__ + "static/mag-slant-29ece3cb535cdde449ad75151580c74c.png";